require('es6-promise').polyfill();
require('es6-object-assign').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/sayt/dist/src/polyfills.js
// module id = 207
// module chunks = 0